export default "__VITE_ASSET__OxI$aVKb__"